import validator from 'validator';
import overviewImg from '../assets/images/cluster-overview-img.svg';
import logoImg from '../assets/images/cluster-logsImg.svg';
import addonsImg from '../assets/images/cluster-logsImg.svg';
import nodegroupsImg from '../assets/images/cluster-nodegroupImg.svg';
import marketplaceImg from '../assets/images/cluster-marketplaceImg.svg';
import overviewImgBlue from '../assets/images/cluster-overview.png';
import logoImgBlue from '../assets/images/cluster-logsImgBlue.svg';
import addonsImgBlue from '../assets/images/cluster-logsImgBlue.svg';
import nodegroupsImgBlue from '../assets/images/cluster-nodegroupImgBlue.svg';
import marketplaceImgBlue from '../assets/images/cluster-marketplaceImgBlue.svg';
import workloadsImg from '../assets/images/workloads-layers-gradient.svg';
// import workloadsImgBlue from '../assets/images/workloads-layers-gradient-blue.svg';
import awsIcon from '@iso/assets/images/aws.svg';
import githubIcon from '@iso/assets/images/aws.svg';
import gitlabIcon from '@iso/assets/images/aws.svg';
import azure from '@iso/assets/images/aws.svg';
import gcp from '@iso/assets/images/aws.svg';
import cloudflare from '@iso/assets/images/aws.svg';
import docker from '@iso/assets/images/aws.svg';
import ecr from '@iso/assets/images/aws.svg';
// import restartBlueButton from '@iso/assets/images/restart-with-blue-background.svg';
import failedRedButton from '@iso/assets/images/failed-with-red-background.svg';
import cancelledRedButton from '@iso/assets/images/cancel-icon-workflow-steps.svg';
import successGreenButton from '@iso/assets/images/success-with-green-background.svg';
import pendingYellowButtonButton from '@iso/assets/images/pending-clock-with-yellow-background.svg';
import clusterSecurity from '@iso/assets/images/clusterSecurity.svg';
import clusterSecuritySelected from '@iso/assets/images/clusterSecuritySelected.svg';
import { InfoCircleFilled, LoadingOutlined, WarningFilled } from "@ant-design/icons";
import yaml from "js-yaml";
import api from '../api';
import rbacSelected from '../assets/images/rbacSelected.svg';
import rbacUnselected from '../assets/images/rbacUnselected.svg';
import costSelected from '../assets/images/costImg.svg';
import costUnselected from '../assets/images/costImgNotActive.svg';
import addonsOverviewImg from "@iso/assets/images/AddonIcon.svg";
import addonsOverviewImgSelected from "@iso/assets/images/AddonIconSelected.svg";
import workloadsIcon from "@iso/assets/images/icon/grid_close_icon.svg";
import workloadsOpenIcon from "@iso/assets/images/icon/grid_open_icon.svg";
import storageIcon from "@iso/assets/images/icon/storage_icon.svg";
import storageOpenIcon from "@iso/assets/images/icon/storage_open_icon.svg";
import loadBalancerIcon from "../assets/images/icon/internet-security.png";
import loadBalancerOpenIcon from "../assets/images/icon/internet-security-open.png";
import EventsIconClose from "@iso/assets/images/icon/events-close.png";
import EventsIconOpen from "@iso/assets/images/icon/events-open.png";
import SreAgentIconClose from "@iso/assets/images/icon/sre-agent-close.svg";
import SreAgentIconOpen from "@iso/assets/images/icon/sre-agent-open.svg";

import { deletePermissionCodenameForBoardSection } from '../constants/permissions';

export { deletePermissionCodenameForBoardSection };

export const daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const ALLOWED_STRING = /^[\w-]+$/;      // or /^[A-Za-z0-9_-]+$/

export const dashboardContent = {
    "no_of_aws_account": "AWS",
    "no_of_github_account": "GitHub",
    "no_of_gitlab_account": "GitLab",
    "no_of_azure_account": "Azure",
    "no_of_gcp_account": "GCP",
    "no_of_cloudflare_account": "Cloudflare",
    "no_of_dockerhub_account": "Docker Hub",
    "no_of_ecr_account": "ECR",
    "no_of_bitbucket_account": "BitBucket",
};

export const clusterIntegrationTypes = {
    1: "AWS",
    2: "AZURE",
    3: "GCP",
    4: "GITHUB",
    5: "GITLAB",
    6: "DOCKERHUB",
    7: "ECR",
    8: "CLOUDFLARE",
    9: "BITBUCKET",
    'undefined': '',
    'null': 'default',
    '' : 'default',
};

export const integrationLogoType = {
    "aws": "no_of_aws_account",
    "github": "no_of_github_account",
    "gitlab": "no_of_gitlab_account",
    "azure": "no_of_azure_account",
    "gcp": "no_of_gcp_account",
    "cloudflare": "no_of_cloudflare_account",
    "dockerhub": "no_of_dockerhub_account",
    "ecr": "no_of_ecr_account",
    "bitbucket": "no_of_bitbucket_account"
};

export const superDashboardContent = {
    "org": "tempOrg",
    "env": "tempEnv",
    "range": "tempRange",
};

// Auth method options
export const authMethodOptions = {
    "assume_role": "Assume Role",
    "access_key": "Access Keys",
    "service_account": "Service Account",
    "Assume Role": "assume_role",
    "Access Keys": "access_key",
    "Service Account": "service_account",
    "-": "-",
    undefined: "-",
    null: "-",
    "": "-",
};

export const dashboardImages = {
    "no_of_aws_account": awsIcon,
    "no_of_github_account": githubIcon,
    "no_of_gitlab_account": gitlabIcon,
    "no_of_azure_account": azure,
    "no_of_gcp_account": gcp,
    "no_of_cloudflare_account": cloudflare,
    "no_of_dockerhub_account": docker,
    "no_of_ecr_account": ecr,
};

export const transformSectionName = {
    "CredentialsManagement": "Credential",
    "InfraWorkspaceRuns": "No Data Found",
    "InfraWorkspaceAssResources": "No Data Found",
    "InfraWorkspaceOutputs": "No Data Found",
};

// export const DyanamicBranchNames = {
//     "Secret Detection": "detect-secrets",
//     "Trivy": "trivy",
//     // "Deploy": "deploy",
//     // "Script": "pre_build_script",
//     "pre_build_script": "Pre build script",
//     "post_build_script": "Post build script",
// };

export const workflowContents = {
    "": "",
    undefined: "",
    null: "",
    0: "",
    "Secret Detection": "detect-secrets",
    "Trivy": "trivy",
    // "Deploy": "deploy",
    // "Script": "pre_build_script",
    "pre_build_script": "Pre build script",
    "post_build_script": "Post build script",
    "post_deploy_script": "Post deploy script",
    "post_deploy": "post_deploy_script",
    "custom_deploy_script": "Custom deploy script",
    "Branch": "branch",
    "branch": "Branch",
    "Wildcard Branch": "wildcard_branch",
    "wildcard_branch": "Wildcard Branch",
    "wildcard branch": "Wildcard Branch",
    "Manual": "manual",
    "manual": "Manual",
    "Automatic": "automatic",
    "automatic": "Automatic",
    "Deploy": "deploy",
    "arm": "arm64",
    "amd": "amd64",
    "arm64": "arm",
    "amd64": "amd",
    "abort": "Abort",
    "skip": "Skip",
};

export const workflowPostDeployNodeText = {
    "immediate": "Immediately",
    "ready": "Rollout completes",
    "delay": "Delay",
    "manual": "Manual",
    "Immediately": "Immediately after deploy",
    "Rollout completes": "After rollout completes (all new Pods Ready)",
    "Delay": "After a delay",
    "Manual": "Manual trigger",
    "application": "Application Container",
    "Application Container": "Application Container (Use deployed image)",
    "ubuntu": "Ubuntu 22.04",
    "alpine": "Alpine Linux",
    "python": "Python 3.9",
    "node": "Node.js 18",
    "custom": "Custom Image",
}

export const workflowNodePipelineStatus = {
    "Succeeded": {
        background: "#E3FBE4",
    },
    "Failed": {
        background: "#FFDCDC",
    },
    "Running": {
        background: "#FFF6DE",
    },
};

export const workflowImgObj = {
    "Pending": pendingYellowButtonButton,
    "Approval Pending": pendingYellowButtonButton,
    "Deploy Pending": pendingYellowButtonButton,
    "Failed": failedRedButton,
    "Success": successGreenButton,
    "Succeeded": successGreenButton,
    "Cancelled": cancelledRedButton,
    "Skipped": cancelledRedButton,
    "Skip": cancelledRedButton,
    "Error": failedRedButton,
    "Rejected": failedRedButton,
    "Running": <div style={{}}>
        <LoadingOutlined style={{ fontSize: "14px", color: "#F6C344" }} />
        {/* <ArrowDownOutlined style={{ transform: "translate(-18px, -3px)", width: "12px", height: "12px" }} /> */}
    </div>
};

export const workflowStatuses = {
    "Running": {
        color: "#F6C344"
    },
    "abort": {
        color: "#D20A0A",
        text: "Abort",
    },
    "skip": {
        color: "#667085",
        text: "Skip",
    },
    "Skipped": {
        color: "#D20A0A",
        text: "Skipped",
    },
    "Success": {
        color: "#008143"
    },
    "Succeeded": {
        color: "#008143"
    },
    "Pending": {
        color: "#F4A460"
    },
    "Deploy Pending": {
        color: "#F4A460"
    },
    "Approval Pending": {
        color: "#F4A460"
    },
    "Failed": {
        color: "#D20A0A"
    },
    "Cancelled": {
        color: "#CB444A"
    },
    "Error": {
        color: "#CB444A"
    },
    "Rejected": {
        color: "#CB444A"
    },
};

const statusSwatches = {
    success: {
        background: "#E3FBE4",
        color: "#0F6B3C",
        border: "1px solid #53A551",
    },
    warning: {
        background: "#FFF6DE",
        color: "#B17300",
        border: "1px solid #FFC107",
    },
    info: {
        background: "#E6F7FF",
        color: "#1078A5",
        border: "1px solid #39cced",
    },
    danger: {
        background: "#FFEAEA",
        color: "#B4232C",
        border: "1px solid #CB444A",
    },
    neutral: {
        background: "#F4F6F8",
        color: "#475467",
        border: "1px solid #D0D5DD",
    },
};

export const statusColors = {
    success: statusSwatches.success,
    succeeded: statusSwatches.success,
    available: statusSwatches.success,
    active: statusSwatches.success,
    deployed: statusSwatches.success,
    healthy: statusSwatches.success,
    ready: statusSwatches.success,
    completed: statusSwatches.success,
    passing: statusSwatches.success,
    running: statusSwatches.warning,
    progressing: statusSwatches.info,
    updating: statusSwatches.warning,
    pending: statusSwatches.warning,
    waiting: statusSwatches.warning,
    warning: statusSwatches.warning,
    deployment_pending: statusSwatches.warning,
    info: statusSwatches.info,
    failed: statusSwatches.danger,
    error: statusSwatches.danger,
    cancelled: statusSwatches.danger,
    degraded: statusSwatches.danger,
    danger: statusSwatches.danger,
    historical: statusSwatches.neutral,
    superseded: statusSwatches.neutral,
    neutral: statusSwatches.neutral,
    paused: statusSwatches.neutral,
    unknown: statusSwatches.neutral,
    default: statusSwatches.neutral,
};

export const workloadStatuses = {
    "Failed": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Available": {
        background: "#53A551",
        color: "white",
        text: "Available",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Progressing": {
        background: "#39cced",
        color: "white",
        text: "Progressing",
        padding: "3px 14px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Unavailable": {
        background: "#cbcbcb",
        color: "#FFFFFF",
        text: "Unavailable",
        padding: "3px 14px",
        border: "#cbcbcb",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
}

export const storagestatuses = {
    "Available": {
        background: "#53A551",
        color: "white",
        text: "Available",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Bound": {
        background: "#53A551",
        color: "white",
        text: "Bound",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Released": {
        background: "#FFC107",
        color: "white",
        text: "Released",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Failed": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Pending": {
        background: "#FFC107",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Lost": {
        background: "#CB444A",
        color: "white",
        text: "Lost",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Attaching": {
        background: "#FFC107",
        color: "white",
        text: "Attaching",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Attached": {
        background: "#53A551",
        color: "white",
        text: "Attached",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "AttachError": {
        background: "#CB444A",
        color: "white",
        text: "Attach Error",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Detaching": {
        background: "#FFC107",
        color: "white",
        text: "Detaching",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Detached": {
        background: "#cbcbcb",
        color: "#FFFFFF",
        text: "Detached",
        padding: "3px 14px",
        border: "#cbcbcb",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DetachError": {
        background: "#CB444A",
        color: "white",
        text: "Detach Error",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
}

export const myClusterStatus = {
    "CLUSTER_FAILED": "Failed",
    "CLUSTER_CREATING": "Creating",
    "CLUSTER_CREATED": "Created",
    "CLUSTER_DESTROYED": "Deleted",
    "BOOTSTRAP_INITIALIZING": "Addons Initialising",
    "BOOTSTRAP_INITIALIZED": "Active",
    "BOOTSTRAP_FAILED": "Failed",
    "BOOTSTRAP_DESTROYING": "Addons Destroying",
    "CLUSTER_DESTROYING": "Deleting",
    "CREATING": "Creating",
    "Creating": "Creating",
    "RUNNING": "Running",
    "Running": "Running",
    "Active": "Active",
    "ACTIVE": "Active",
    "DELETING": "Deleting",
    "FAILED": "Failed",
    "UPDATING": "Updating",
    "PENDING": "Pending",
    "Out Of Sync": "Out Of Sync",
    "CLUSTER_DESTROY_FAILED": "Failed",
    // "CLUSTER_UPDATING": "Cluster Updating",
    "CLUSTER_UPDATING": "Updating",
    "CLUSTER_UPDATED": "Cluster Updated",
    "UPDATE_FAILED": "Update Failed",
    "NODEGROUP_CREATING": "Nodegroup Creating",
    "NODEGROUP_CREATED": "Nodegroup Created",
    "NODEGROUP_FAILED": "Nodegroup Failed",
    "NODEGROUP_DESTROYING": "Nodegroup Destroying",
    "NODEGROUP_DESTROYED": "Nodegroup Destroyed",
    "ADDON_DESTROYING": "Addon Destroying",
    "ADDON_DESTROY_FAILED": "Addon Destroy Failed",
    "NODEGROUP_DESTROY_FAILED": "Nodegroup Destroy Failed",
    "NODEGROUP_UPDATING": "Nodegroup Updating",
    "NODEGROUP_UPDATE_FAILED": "Nodegroup Update Failed",
    "NODEGROUP_UPDATED": "Nodegroup Updated",
    "ADDON_UPDATING": "Addon Updating",
    "ADDON_UPDATED": "Addon Updated",
    "ADDON_UPDATE_FAILED": "Addon Update Failed",
    "IMPORTING": "Importing",
    "IMPORTING_FAILED": "Import Failed",
    "CLUSTER_UPDATE_FAILED": "Cluster Update Failed",
    "ERROR": "Failed",
    "UNKNOWN": "Unknown",
    "PROVISIONING": "Creating",
    "RECONCILING": "Active",
    "RUNNING": "Active",
    "STOPPING": "Deleting",
    "DEGRADED": "Deleted",
};

export const provisionerStatuses = {
    "default": {
        border: "2px solid",
        backgroundColor: "white",
        color: "#9b9b9b",
        padding: "1px 14px",
        borderRadius: "17px",
        display: "flex",
        justifyContent: "center",
        fontFamily: "Nunito Sans"
    },
    "atmosly": {
        border: "2px solid",
        backgroundColor: "white",
        color: "#46C0FD",
        padding: "1px 14px",
        borderRadius: "17px",
        display: "flex",
        justifyContent: "center",
        fontFamily: "Nunito Sans"
    },
    "imported": {
        border: "2px solid",
        backgroundColor: "white",
        color: "#EFA00C",
        padding: "1px 14px",
        borderRadius: "17px",
        display: "flex",
        justifyContent: "center",
        fontFamily: "Nunito Sans"
    }
};

export const nodegroupStatuses = {
    "Failed": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "Creating": {
        color: "#343434",
        background: "#FFC107",
    },
    "Created": {
        color: "#FFFFFF",
        background: "#53A551",
    },
    "Active": {
        color: "#FFFFFF",
        background: "#53A551",
    },
    "Updating": {
        color: "#343434",
        background: "#FFC107",
    },
    "Update Failed": {
        color: "#FFFFFF",
        background: "#980000",
    },
    "Create_Failed": {
        color: "#FFFFFF",
        background: "#CB444A",
        text: "Create Failed"
    },
    "Create_failed": {
        color: "#FFFFFF",
        background: "#CB444A",
        text: "Create Failed"
    },
    "create_failed": {
        color: "#FFFFFF",
        background: "#CB444A",
        text: "Create Failed"
    },
    "Degraded": {
        color: "#343434",
        background: "#FFA500",
        text: "Degraded"
    },
    "degraded": {
        color: "#343434",
        background: "#FFA500",
        text: "Degraded"
    },
    "Destroying": {
        color: "#343434",
        background: "#FFC107",
    },
    "Deleting": {
        color: "#343434",
        background: "#FFC107",
    },
    "Destroy Failed": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "inactive": {
        color: "#FFFFFF",
        background: "#808080",
    },
    "Inactive": {
        color: "#FFFFFF",
        background: "#808080",
    },
};
export const clusterStatuses = {
    "CLUSTER_FAILED": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "IMPORTING_FAILED": {
        background: "rgb(203, 68, 74)",
        color: "white",
        padding: "3px 14px",
        text: "Import Failed",
        fontFamily: "Nunito Sans",
        borderRadius: "17px"
    },
    "IMPORTING": {
        background: "#16BFD6",
        color: "black",
        padding: "3px 14px",
        text: "Importing",
        fontFamily: "Nunito Sans",
        borderRadius: "17px"
    },
    "importing": {
        background: "#16BFD6",
        color: "black",
        padding: "3px 14px",
        text: "Importing",
        fontFamily: "Nunito Sans",
        borderRadius: "17px"
    },
    "CLUSTER_CREATING": {
        background: "#FFC107",
        color: "#343434",
        text: "Creating",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_CREATED": {
        background: "#53A551",
        color: "white",
        text: "Created",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_DESTROYED": {
        background: "#CB444A",
        color: "white",
        // text: "Destroyed",
        text: "Deleted",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "BOOTSTRAP_INITIALIZING": {
        background: "#FFC107",
        color: "#343434",
        text: "Addons Initialising",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "BOOTSTRAP_INITIALIZED": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "BOOTSTRAP_FAILED": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "BOOTSTRAP_DESTROYING": {
        background: "#DBA1A1",
        color: "white",
        text: "Addons Destroying",
        padding: "3px 14px",
        border: "#DBA1A1",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_DESTROYING": {
        background: "#DBA1A1",
        color: "white",
        // text: "Destroying",
        text: "Deleting",
        padding: "3px 14px",
        border: "#DBA1A1",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CREATING": {
        background: "#FFC107",
        color: "#343434",
        text: "Creating",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Running": {
        background: "#FFC107",
        color: "#1f1f1f",
        text: "Running",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "RUNNING": {
        background: "#FFC107",
        color: "#1f1f1f",
        text: "Running",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Active": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "active": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ACTIVE": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "PASSED": {
        background: "#53A551",
        color: "white",
        text: "passed",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Completed": {
        background: "#53A551",
        color: "white",
        text: "Completed",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DELETING": {
        background: "#DBA1A1",
        color: "white",
        text: "Deleting",
        padding: "3px 14px",
        border: "#DBA1A1",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "FAILED": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Failed": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UPDATING": {
        background: "#FFA07A",
        color: "white",
        text: "Updating",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "PENDING": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Pending": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Out Of Sync": {
        background: "#CB444A",
        color: "white",
        text: "Out Of Sync",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Agent Disconnected": {
        background: "#FF8C00",
        color: "white",
        text: "Agent Disconnected",
        padding: "3px 14px",
        border: "#FF8C00",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_DESTROY_FAILED": {
        // text: "Destroy Failed",
        text: "Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ADDON_DESTROY_FAILED": {
        text: "Addon Destroy Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ADDON_UPDATING": {
        text: "Updating",
        color: "#343434",
        background: "#FFC107",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ADDON_UPDATED": {
        background: "#53A551",
        color: "white",
        text: "Updated",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ADDON_UPDATE_FAILED": {
        text: "Addon Update Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UPDATE_FAILED": {
        text: "Update Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_UPDATING": {
        text: "Updating",
        color: "#FFFFFF",
        background: "#FFC107",
        padding: "3px 14px",
        border: "1px solid #FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_UPDATED": {
        background: "#53A551",
        color: "white",
        text: "Cluster Updated",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_CREATING": {
        text: "Nodegroup Creating",
        color: "#343434",
        background: "#FFC107",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_CREATED": {
        text: "Nodegroup Created",
        color: "#FFFFFF",
        background: "#53A551",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_FAILED": {
        text: "Nodegroup Failed",
        color: "#FFFFFF",
        background: "#CB444A",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_DESTROYING": {
        text: "Nodegroup Destroying",
        background: "#DBA1A1",
        color: "white",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_DESTROYED": {
        background: "#CB444A",
        color: "white",
        text: "Nodegroup Destroyed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_DESTROY_FAILED": {
        text: "Nodegroup Destroy Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_UPDATING": {
        text: "Nodegroup Updating",
        color: "#343434",
        background: "#FFC107",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_UPDATE_FAILED": {
        text: "Nodegroup Update Failed",
        color: "#FFFFFF",
        background: "#CB444A",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "NODEGROUP_UPDATED": {
        background: "#53A551",
        color: "white",
        text: "Nodegroup Updated",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DESTROYING": {
        text: "Destroying",
        background: "#DBA1A1",
        color: "white",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UPDATING": {
        text: "Updating",
        color: "#343434",
        background: "#FFC107",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UPDATE FAILED": {
        text: "Addon Update Failed",
        background: "#980000",
        color: "white",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DESTROY FAILED": {
        text: "Addon Destroy Failed",
        background: "#980000",
        color: "white",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "CLUSTER_UPDATE_FAILED": {
        text: "Cluster Update Failed",
        background: "#980000",
        color: "white",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Healthy": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Provisioning": {
        background: "#FFC107",
        color: "#1f1f1f",
        text: "Creating",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "PROVISIONING": {
        background: "#FFC107",
        color: "#1f1f1f",
        text: "Creating",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Updating": {
        background: "#FFA07A",
        color: "white",
        text: "Updating",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deleting": {
        background: "#DBA1A1",
        color: "white",
        text: "Destroying",
        padding: "3px 14px",
        border: "#DBA1A1",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Error": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ERROR": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Destroyed": {
        background: "#CB444A",
        color: "white",
        text: "Destroyed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deleted": {
        background: "#CB444A",
        color: "white",
        text: "Deleted",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Unknown": {
        background: "#B7B7B7",
        color: "#FFFFFF",
        text: "Unknown",
        padding: "3px 14px",
        border: "#B7B7B7",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UNKNOWN": {
        background: "#B7B7B7",
        color: "#FFFFFF",
        text: "Unknown",
        padding: "3px 14px",
        border: "#B7B7B7",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "RECONCILING": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "STOPPING": {
        background: "#DBA1A1",
        color: "white",
        text: "Deleting",
        padding: "3px 14px",
        border: "#DBA1A1",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "ERROR": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    //...nodegroupStatuses
};
export const nodesStatuses = {
    "running": {
        color: "#343434",
        background: "#FFC107",
    },
    "terminated": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "shutting-down": {
        color: "#343434",
        background: "#CB444A",
    },
    "pending": {
        background: "#DBA1A1",
        color: "white",
    },
    "stopped": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "rebooting": {
        background: "#FFC107",
        color: "#343434",
    }
}
export const PodsStatuses = {
    "Running": {
        color: "#343434",
        background: "#FFC107",
    },
    "Terminating": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "Succeeded": {
        color: "#FFFFFF",
        background: "#53A551",
    },
    "Pending": {
        color: "white",
        background: "#FFA07A",
    },
    "Failed": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "Unknown": {
        background: "#DBA1A1",
        color: "white",
    },
    "CrashLoopBackOff": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "ImagePullBackOff": {
        background: "#DBA1A1",
        color: "white",
    },
    "ImagePullError": {
        color: "#FFFFFF",
        background: "#CB444A",

    },
    "Available": {
        color: "#FFFFFF",
        background: "#53A551",
    },
    "Scheduled": {
        color: "white",
        background: "#FFA07A",
    },
    "Progressing": {
        color: "#FFFFFF",
        background: "#39cced",
    },
    "Complete": {
        color: "#FFFFFF",
        background: "#53A551",
    },
    "ErrImagePull": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "ContainerCreating": {
        color: "white",
        background: "#FFA07A",
    },
    "Suspended": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
}

// Pod status can be any kubectl STATUS string, including dynamic ones the map
// can't enumerate (Init:0/2, Signal:9, ExitCode:137, OOMKilled, Completed,
// NotReady, Evicted, ...). Look up the exact match first, then fall back to a
// semantic category by keyword so every status still renders as a badge.
export const getPodStatusStyle = (status) => {
    if (!status) return { background: "#E0E0E0", color: "#343434" };
    if (PodsStatuses[status]) return PodsStatuses[status];

    const s = String(status).toLowerCase();
    if (/(err|error|backoff|oom|evict|exitcode|signal|invalid|fail|lost|unknown|notready|deadline|forbidden|conflict)/.test(s)) {
        return { background: "#CB444A", color: "#FFFFFF" };   // error → red
    }
    if (/(init|creating|pending|schedul|progress|terminat|waiting|pull)/.test(s)) {
        return { background: "#FFA07A", color: "#FFFFFF" };   // transitional → orange
    }
    if (/(running|complet|succeed|ready|available)/.test(s)) {
        return { background: "#53A551", color: "#FFFFFF" };   // healthy → green
    }
    return { background: "#E0E0E0", color: "#343434" };       // unknown → neutral
};

export const EventStatuses = {
    "Normal": {
        color: "#343434",
        background: "#E8F5E9",
    },
    "Warning": {
        color: "#343434",
        background: "#FFF3E0",
    },
    "Error": {
        color: "#FFFFFF",
        background: "#CB444A",
    },
}

// SRE Agent issue severity badges — follows the same pill style as
// workloadStatuses / PodsStatuses: background fill with contrasting text,
// rounded pill shape (borderRadius 17), Nunito Sans font.
export const sreAgentSeverityStatuses = {
    "Critical": {
        background: "#CB444A",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "High": {
        background: "#FA541C",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "Warning": {
        background: "#FAAD14",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "Medium": {
        background: "#FAAD14",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "Info": {
        background: "#1890FF",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "Low": {
        background: "#53A551",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "Unknown": {
        background: "#cbcbcb",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
}

// SRE Agent RCA / AI analysis chips — same pill style as sreAgentSeverityStatuses.
export const sreAgentRcaTagStatuses = {
    "AI generated": {
        background: "#53A551",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
    "Standard recommendations": {
        background: "#8c8c8c",
        color: "#FFFFFF",
        padding: "3px 14px",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
    },
}

export const clusterAddonFormat = {
    "cert_manager_enabled": "Cert Manager Enabled",
    "create_efs_storage_class": "Create Efs Storage Class",
    "nginx_alb_controler": "Enable Ingress ALB Controller",
    "nginx_ingress_controler": "Enable Nginx Ingress Controller",
    "pgl_stack": "grafana-stack",

    "Cert Manager": "cert_manager_enabled",
    "EFS Storage Class": "create_efs_storage_class",
    "Ingress ALB Controller": "nginx_alb_controler",
    "Nginx Ingress Controller": "nginx_ingress_controler",
    "grafana-stack": "pgl_stack",
    "K8s Dashboard": "k8s_dashboard",
    "kubernetes-dashboard": "k8s_dashboard",
    "ArgoFlow": "argoFlow",
    "argo-workflow": "argoFlow",
    "Reloader": "enable_reloader"
    // "enable_ingress_nginx": "-",
    // "cert_manager_install_letsencrypt_http_issuers": "-",
    // "cert_manager_letsencrypt_email": "-",
    // "create_service_monitor_crd": "-",
    // "enable_amazon_eks_aws_ebs_csi_driver": "-",
    // "enable_amazon_eks_vpc_cni": "-",
    // "enable_aws_node_termination_handler": "-",
    // "enable_cluster_autoscaler": "-",
    // "enable_cluster_propotional_autoscaler": "-",
    // "enable_external_secrets": "-",
    // "enable_istio": "-",
    // "enable_karpenter": "-",
    // "enable_keda": "-",
    // "enable_metrics_server": "-",
    // "enable_reloader": "-",
    // "enable_single_az_ebs_gp3_storage_class": "-",
    // "karpenter_provisioner_enabled": "-",
};

export const clusterAddonsContext = {
    "Cert Manager": "cert_manager_enabled",
    "Istio": "enable_istio",
    "EFS Storage Class": "create_efs_storage_class",
    "Karpenter": "enable_karpenter",
    "External Secrets": "enable_external_secrets",
    "Ingress ALB Controller": "nginx_alb_controler",
    "Nginx Ingress Controller": "nginx_ingress_controler",
    "Grafana Stack": "pgl_stack",
    "K8s Dashboard": "k8s_dashboard",
    "kubernetes-dashboard": "k8s_dashboard",
    "ArgoFlow": "argoFlow",
    "argo-workflow": "argoFlow",
    "Keda": "enable_keda",
    "Reloader": "enable_reloader"
}


export const enumImgs = {
    "Cluster Details": overviewImg,
    "Cluster Logs": logoImg,
    "Addons Logs": addonsImg,
    "Nodegroups & Pods": nodegroupsImg,
    "Nodepools & Pods": nodegroupsImg,
    "Addons Details": addonsOverviewImg,
    "Addons Details Active": addonsOverviewImgSelected,
    "Helm Charts": marketplaceImg,
    "Workloads": workloadsIcon,
    "Storage": storageIcon,
    "Ingress & Service Accounts": loadBalancerIcon,
    "Cluster Events": EventsIconClose,
    "Cluster Details Active": overviewImgBlue,
    "Cluster Logs Active": logoImgBlue,
    "Addons Logs Active": addonsImgBlue,
    "Nodegroups & Pods Active": nodegroupsImgBlue,
    "Nodepools & Pods Active": nodegroupsImgBlue,
    "Helm Charts Active": marketplaceImgBlue,
    "Workloads Active": workloadsOpenIcon,
    "Storage Active": storageOpenIcon,
    "Ingress & Service Accounts Active": loadBalancerOpenIcon,
    "Cluster Events Active": EventsIconOpen,
    "RBAC": rbacUnselected,
    "RBAC Active": rbacSelected,
    "Security": clusterSecurity,
    "Security Active": clusterSecuritySelected,
    "Cost Optimization Active": costSelected,
    "Cost Optimization": costUnselected,
    // SRE Agent — dedicated robot/agent icon (line-art monitor with
    // pulse signal). Visual language matches the rest of the sidebar:
    // grey for inactive, #4D99EF for active.
    "SRE Agent": SreAgentIconClose,
    "SRE Agent Active": SreAgentIconOpen,
}

export const marketplaceStatuses = {
    "DEPLOY_FAILED": {
        text: "Failed",
        color: "#FFFFFF",
        background: "#CB444A",
        border: "#CB444A",
    },
    "DELETE_FAILED": {
        text: "Delete Failed",
        color: "#FFFFFF",
        background: "#CB444A",
        border: "#CB444A",
    },
    "UPDATE_FAILED": {
        text: "Update Failed",
        color: "#FFFFFF",
        background: "#CB444A",
        border: "#CB444A",
    },
    "DEPLOYING": {
        text: "Deploying",
        color: "#FFFFFF",
        background: "#FFC107",
        border: "1px solid #F6C344",
    },
    "UPDATING": {
        text: "Updating",
        color: "#FFFFFF",
        background: "#FFC107",
        border: "1px solid #F6C344",
    },
    "DEPLOYED": {
        text: "Deployed",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
    },
    "DELETING": {
        text: "Deleting",
        color: "#FFFFFF",
        background: "#e38084",
        border: "1px solid #e38084",
    },
    "HEALTHY": {
        text: "Healthy",
        color: "#53A551",
        background: "#FFC107",
        border: "1px solid #F6C344",
    },
    "UNHEALTHY": {
        text: "Unhealthy",
        color: "#D20A0A",
        background: "#FFC107",
        border: "1px solid #F6C344",
    },
    "PROGRESSING": {
        text: "Progressing",
        color: "#39cced",
        background: "#39cced",
        border: "1px solid #39cced",
    },
    "UNKNOWN": {
        text: "Unknown",
        background: "#DBA1A1",
        color: "#DBA1A1",
        border: "1px solid #DBA1A1"
    },
    "DEGRADED": {
        text: "Degraded",
        color: "#980000",
    },
    "SUSPENDED": {
        text: "Suspended",
        color: "#CB444A",
    },
    "MISSING": {
        text: "Missing",
        color: "#808080",
        border: "1px solid #808080",
    }
};

// Index = pipeline type - 1 (1 CI, 2 app deploy, 3 cron deploy, 4 worker deploy).
export let releaseTypes = ["App CI", "App CD", "Cron deploy", "Worker deploy"];

export const environmentStatuses = {
    "release_failed": {
        text: "Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Unhealthy": {
        text: "Unhealthy",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Failed": {
        text: "Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "FAILED": {
        text: "Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "failed": {
        text: "Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Terminating": {
        text: "Terminating",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Terminated": {
        text: "Terminated",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    // "Terminated": {
    //     text: "Terminated",
    //     color: "#FFFFFF",
    //     padding: "3px 14px",
    //     background: "#CBCBCB",
    //     border: "#CBCBCB",
    //     borderRadius: "17px",
    //     fontFamily: "Nunito Sans"
    // },
    "Termination Failed": {
        text: "Termination Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Passed": {
        text: "Passed",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "PASSED": {
        text: "Passed",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Skipped": {
        text: "Skipped",
        padding: "3px 14px",
        color: 'white',
        background: "#CB444A",
        // color: 'black',
        // background: "#CBCBCB",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Healthy": {
        text: "Completed",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Complete": {
        text: "Complete",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Succeeded": {
        text: "Succeeded",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "SUCCEEDED": {
        text: "Succeeded",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Active": {
        text: "Active",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Completed": {
        text: "Completed",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Running": {
        text: "Running",
        color: "#1f1f1f",
        background: "#FFC107",
        padding: "3px 14px",
        border: "1px solid #FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deployment Pending": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Approval Pending": {
        background: "#FFA07A",
        color: "white",
        text: "Approval Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Approval Rejected": {
        text: "Approval Rejected",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "running": {
        text: "Running",
        color: "#1f1f1f",
        background: "#FFC107",
        padding: "3px 14px",
        border: "1px solid #FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "progressing": {
        text: "Progressing",
        color: "#ffffff",
        background: "#39cced",
        padding: "3px 14px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "PROGRESSING": {
        text: "Progressing",
        color: "#ffffff",
        background: "#39cced",
        padding: "3px 14px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "installing": {
        text: "Installing",
        color: "#ffffff",
        background: "#39cced",
        padding: "3px 14px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "INSTALLING": {
        text: "Installing",
        color: "#ffffff",
        background: "#39cced",
        padding: "3px 14px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "PENDING": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Pending": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deploy Pending": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "pending/stopped": {
        background: "#FFA07A",
        color: "white",
        text: "Pending/Stopped",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deployment Pending": {
        background: "#FFC107",
        color: "#343434",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "missing": {
        text: "Missing",
        color: "#ffffff",
        background: "#808080",
        padding: "3px 14px",
        border: "1px solid #808080",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "degraded": {
        text: "Degraded",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "healthy": {
        text: "Healthy",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "unhealthy": {
        text: "Unhealthy",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "failed": {
        text: "Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DEPLOYING": {
        text: "Deploying",
        color: "#ffffff",
        background: "#39cced",
        padding: "3px 14px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Initialising": {
        text: "Initialising",
        color: "#ffffff",
        background: "#808080",
        padding: "3px 14px",
        border: "1px solid #808080",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DEPLOY_FAILED": {
        text: "Deploy Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DEPLOYED": {
        text: "Deployed",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UPDATING": {
        text: "Updating",
        color: "#FFFFFF",
        background: "#FFC107",
        padding: "3px 14px",
        border: "1px solid #FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Updating": {
        text: "Updating",
        color: "#FFFFFF",
        background: "#1e90ff",
        padding: "3px 14px",
        border: "1px solid #1e90ff",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "UPDATE_FAILED": {
        text: "Update Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DELETING": {
        text: "Deleting",
        color: "#ffffff",
        background: "#e38084",
        padding: "3px 14px",
        border: "1px solid #e38084",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deleting": {
        text: "Deleting",
        color: "#ffffff",
        background: "#e38084",
        padding: "3px 14px",
        border: "1px solid #e38084",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Destroying": {
        text: "Destroying",
        color: "#ffffff",
        background: "#e38084",
        padding: "3px 14px",
        border: "1px solid #e38084",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DELETE_FAILED": {
        text: "Delete Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Error": {
        text: "Error",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "DELETED": {
        text: "Deleted",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Destroyed": {
        text: "Destroyed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Destroy Failed": {
        text: "Destroy Failed",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#980000",
        border: "#980000",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Service Unavailable": {
        text: "Service Unavailable",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#cbcbcb",
        border: "#cbcbcb",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Scaling Up": {
        text: "Scaling Up",
        color: "#ffffff",
        padding: "3px 14px",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Scaling Down": {
        text: "Scaling Down",
        color: "#ffffff",
        padding: "3px 14px",
        background: "#FF9800",
        border: "#FF9800",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Unavailable": {
        text: "Unavailable",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#cbcbcb",
        border: "#cbcbcb",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Cancelled": {
        text: "Cancelled",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Partially Active": {
        text: "Partially Active",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#8ABF89",
        border: "#8ABF89",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Partially Stop": {
        text: "Partially Stop",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#8ABF89",
        border: "#8ABF89",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Unknown": {
        text: "Unknown",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#B7B7B7",
        border: "#B7B7B7",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },

    "stopped": {
        text: "Stopped",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#cbcbcb",
        border: "#cbcbcb",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },

    "stopping": {
        text: "Stopping",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#cbcbcb",
        border: "#cbcbcb",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "starting": {
        text: "Starting",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Rejected": {
        text: "Rejected",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
};

export const addonsStatuses = {
    "SUCCEEDED": {
        text: "Succeeded",
        padding: "4px 10px",
        color: "#53A551",
        // background: "#53A551",
        border: "1px solid #53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
    "PROGRESSING": {
        text: "Progressing",
        color: "#39cced",
        // background: "#39cced",
        padding: "4px 10px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
    "INSTALLING": {
        text: "Installing",
        color: "#39cced",
        // background: "#39cced",
        padding: "4px 10px",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
    "UPDATING": {
        text: "Updating",
        color: "#FFC107",
        // background: "#FFC107",
        padding: "4px 10px",
        border: "1px solid #FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
    "DELETING": {
        text: "Deleting",
        color: "#e38084",
        // background: "#e38084",
        padding: "4px 10px",
        border: "1px solid #e38084",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
    "FAILED": {
        text: "Failed",
        color: "#CB444A",
        padding: "4px 10px",
        border: "1px solid #CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
    // Agent addon installed OK but its pod hasn't reported in >5min (agent_flavours).
    // Orange matches the "Agent Disconnected" cluster status / connectivity banner.
    "DISCONNECTED": {
        text: "Disconnected",
        color: "#FF8C00",
        padding: "4px 10px",
        border: "1px solid #FF8C00",
        borderRadius: "17px",
        fontFamily: "Nunito Sans",
        fontWeight: "500",
        fontSize: "12px",
    },
}

export const integrationStatuses = {
    "Active": {
        text: "Active",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "active": {
        text: "Active",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#53A551",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Inactive": {
        text: "Inactive",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#FFA07A",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "inactive": {
        text: "Inactive",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#FFA07A",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Retrying": {
        text: "Retrying",
        padding: "3px 14px",
        color: "#ffffff",
        background: "#39cced",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "retrying": {
        text: "Retrying",
        padding: "3px 14px",
        color: "#ffffff",
        background: "#39cced",
        border: "1px solid #39cced",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deleted": {
        text: "Deleted",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "deleted": {
        text: "Deleted",
        padding: "3px 14px",
        color: "#FFFFFF",
        background: "#CB444A",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
}

export const auditActionStatuses = {
    // Basic CRUD Operations
    "created": {
        text: "Created",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "updated": {
        text: "Updated",
        color: "#343434",
        background: "#FFC107",
    },
    "deleted": {
        text: "Deleted",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    // Service Operations
    "service_created": {
        text: "Service Created",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "service_updated": {
        text: "Service Updated",
        color: "#343434",
        background: "#FFC107",
    },
    "service_deleted": {
        text: "Service Deleted",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "service_add_requested": {
        text: "Service Add Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "service_update_requested": {
        text: "Service Update Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "environment variables updated": {
        text: "Environment Variables Updated",
        color: "#343434",
        background: "#FFC107",
    },
    // Requested Operations (async/pending)
    "create_requested": {
        text: "Create Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "update_requested": {
        text: "Update Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "delete_requested": {
        text: "Delete Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "deploy_requested": {
        text: "Deploy Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "upgrade_requested": {
        text: "Upgrade Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "start_requested": {
        text: "Start Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "stop_requested": {
        text: "Stop Requested",
        color: "#343434",
        background: "#FFC107",
    },
    // Completed Operations
    "started": {
        text: "Started",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "stopped": {
        text: "Stopped",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    // Scaling Operations
    "scale_up_requested": {
        text: "Scale Up Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "scale_down_requested": {
        text: "Scale Down Requested",
        color: "#343434",
        background: "#FFC107",
    },
    "scaled_up": {
        text: "Scaled Up",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "scaled_down": {
        text: "Scaled Down",
        color: "#343434",
        background: "#FFC107",
    },
    // Workload Operations
    "rolled_back": {
        text: "Rolled Back",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    "applied": {
        text: "Applied",
        color: "#FFFFFF",
        background: "#53A551",
    },
    // Workflow Operations
    "ci_started": {
        text: "CI Started",
        color: "#FFFFFF",
        background: "#53A551",
    },
    // Secret Operations
    "secret_connected": {
        text: "Secret Connected",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "secret_disconnected": {
        text: "Secret Disconnected",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    // Cluster Operations
    "addons_change_requested": {
        text: "Addons Change Requested",
        color: "#343434",
        background: "#FFC107",
    },
    // Guardrail Operations
    "enabled": {
        text: "Enabled",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "disabled": {
        text: "Disabled",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    // Terminal Operations
    "connect": {
        text: "Connect",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "disconnect": {
        text: "Disconnect",
        color: "#FFFFFF",
        background: "#CB444A",
    },
    // GitOps · Right-sizing actuation
    "confirmed": {
        text: "Confirmed",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "rightsize_source_confirmed": {
        text: "Source Confirmed",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "raised": {
        text: "PR Raised",
        color: "#343434",
        background: "#FFC107",
    },
    "rightsize_pr_raised": {
        text: "PR Raised",
        color: "#343434",
        background: "#FFC107",
    },
    "rightsize_applied": {
        text: "Applied",
        color: "#FFFFFF",
        background: "#53A551",
    },
    "cleared": {
        text: "Cleared",
        color: "#FFFFFF",
        background: "#CB444A",
    },
}

// Shared palette for audit-action pills. Kept as named tones so the keyword
// fallback below stays in lock-step with the explicit entries above.
export const auditActionPalette = {
    positive: { color: "#FFFFFF", background: "#53A551" }, // created / applied / enabled / connected …
    pending: { color: "#343434", background: "#FFC107" },  // *_requested / raised / updated / scaling …
    negative: { color: "#FFFFFF", background: "#CB444A" }, // deleted / cleared / disconnect / failed …
    neutral: { color: "#343434", background: "#E5E7EB" },  // truly unrecognised — readable grey
};

// Resolve the pill style for an audit action. Returns the explicit entry when
// one exists; otherwise derives a tone from keywords in the action name and
// falls back to a neutral grey. This guarantees a brand-new backend action
// renders a readable, sensibly-coloured pill instead of bare text.
export const getAuditActionStyle = (action) => {
    if (!action) return null;
    const key = String(action).toLowerCase();
    if (auditActionStatuses[key]) return auditActionStatuses[key];

    const text = key
        .replace(/_/g, " ")
        .split(" ")
        .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
        .join(" ");
    const has = (re) => re.test(key);

    let tone = "neutral";
    if (has(/(delete|remove|clear|disconnect|disable|revert|rollback|rolled_back|stop|fail|terminat|destroy|drift|reject|denied|expire)/)) {
        tone = "negative";
    } else if (has(/(request|pending|raise|queue|scale|updat|change|in_progress|awaiting|review|retry|trigger)/)) {
        tone = "pending";
    } else if (has(/(creat|add|apply|appli|confirm|connect|enable|start|success|succeed|complete|done|resolve|approve|merge|grant|restore)/)) {
        tone = "positive";
    }
    return { ...auditActionPalette[tone], text };
};

export const NoDataContent = {
    Cluster: {
        title: "No Data",
        subTitle: "Let's add your first cluster in ATMOSLY.",
        buttontext: "Add Cluster"
    },
    Project: {
        title: "No Data",
        subTitle: "Let's add your first project in ATMOSLY.",
        buttontext: "Add Project"
    },
    Service: {
        title: "No Data",
        subTitle: "Let's create your first service in ATMOSLY.",
        buttontext: "Run Scan"
    },
    RolesAndPermissions: {
        title: "No Data",
        subTitle: "Let's create your first cluster in ATMOSLY.",
        buttontext: "Run Scan"
    },
    Pipelines: {
        title: "No Data",
        subTitle: "Let's create your first cluster in ATMOSLY.",
        buttontext: "Run Scan"
    },
    SecurityVulnerabilities: {
        title: "No Data",
        subTitle: "Let's perform your first security scan in ATMOSLY.",
        buttontext: "Run Scan"
    },
}

export const commonStatus = {
    "Active": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "active": {
        background: "#53A551",
        color: "white",
        text: "Active",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Failed": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "failed": {
        background: "#CB444A",
        color: "white",
        text: "Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deleted": {
        background: "#CB444A",
        color: "white",
        text: "Deleted",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "deleted": {
        background: "#CB444A",
        color: "white",
        text: "Deleted",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "InActive": {
        background: "#CB444A",
        color: "white",
        text: "In Active",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "inactive": {
        background: "#CB444A",
        color: "white",
        text: "In Active",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Terminating": {
        text: "Terminating",
        color: "#FFFFFF",
        padding: "3px 14px",
        background: "#f45456",
        border: "#f45456",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Terminated": {
        background: "#ca5f64",
        color: "white",
        text: "Terminated",
        padding: "3px 14px",
        border: "#ca5f64",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Termination Failed": {
        background: "#CB444A",
        color: "white",
        text: "Termination Failed",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Running": {
        background: "rgba(92, 215, 255, 1)",
        color: "#1f1f1f",
        text: "Running",
        padding: "3px 14px",
        border: "rgba(92, 215, 255, 1)",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Succeeded": {
        background: "#53A551",
        color: "white",
        text: "Succeeded",
        padding: "3px 14px",
        border: "#53A551",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Pending": {
        background: "#FFA07A",
        color: "white",
        text: "Pending",
        padding: "3px 14px",
        border: "#FFA07A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Deployment Pending": {
        background: "#FFC107",
        color: "#343434",
        text: "Deployment Pending",
        padding: "3px 14px",
        border: "#FFC107",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Approval Pending": {
        background: "#ffa07a",
        color: "white",
        text: "Approval Pending",
        padding: "3px 14px",
        border: "#ffa07a",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
    "Approval Rejected": {
        background: "#CB444A",
        color: "white",
        text: "Approval Rejected",
        padding: "3px 14px",
        border: "#CB444A",
        borderRadius: "17px",
        fontFamily: "Nunito Sans"
    },
}

export const enums = {
    "ondemand": "ON_DEMAND",
    "spot": "SPOT",
    "ON_DEMAND": "ondemand",
    "SPOT": "spot",
    "on-demand": "ON_DEMAND",
    "On-demand": "ondemand",
    "amazon_linux_2_amd": "Amazon Linux-2 AMD",
    "amazon_linux_2_arm": "Amazon Linux-2 ARM",
    "amazon_linux_2023_amd": "Amazon Linux-2023 AMD",
    "amazon_linux_2023_arm": "Amazon Linux-2023 ARM",
    "gke_amd64": "GKE AMD64",
    "gke_arm64": "GKE ARM64",
    "cos_containerd": "COS Containerd",
    "ubuntu_containerd": "Ubuntu Containerd",
    "COS_CONTAINERD": "COS Containerd",
    "UBUNTU_CONTAINERD": "Ubuntu Containerd",
};

let envRegex = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?$/;

export const validatePassword = (rule, value, callback) => {
    let val = value.trim();
    if (val === "") {
        callback();
    }
    else {
        if (val.length < 8) {
            callback("Password must have at least 8 characters.");
        }
        else {
            callback();
        }
    }
}

export const validateAwsPassword = (rule, value, callback) => {
    let val = value?.toString().trim();
    const regex = /^(?!.*[;@\"',])[\x20-\x7E]*$/;
    if (!regex.test(val)) {
        callback("Password must only contain printable ASCII characters and must not include any of the following: ';', '@', '\"', ','.");
    }
    else {
        callback();
    }
}


export const validateName = (rule, value, callback) => {
    let val = "";
    if (value) {
        val = value?.toString().trim();
    }
    // let myRegex = /^[a-z0-9]([_a-z0-9]*[a-z0-9])?$/;
    if (rule.field === "appName") {
        if (!val) {
            callback("Please enter app name!");
        }
        else if (!/^[a-z0-9]/.test(val)) {
            callback("App name must start with a lowercase letter or a digit.");
        }
        else if (/[^-a-z0-9]/.test(val)) {
            callback("App name can only contain lowercase letters, digits, and hyphens.");
        }
        else if (!/[a-z0-9]$/.test(val)) {
            callback("App name must end with a lowercase letter or a digit.");
        }
        else {
            if (val.length > 63) {
                callback("App name should have at most 63 characters.");
            }
            else {
                callback();
            }
        }
    }
    else if (rule.field === "displayName") {
        const displayNameRegex = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/;
        if (!val) {
            callback("Please enter display name!");
        }
        else if (!/^[a-z0-9]/.test(val)) {
            callback("Display name must start with a lowercase letter or a digit.");
        }
        else if (/[^a-z0-9.\-]/.test(val)) {
            callback("Display name can only contain lowercase letters, digits, hyphens, and dots (e.g. name or name.subname).");
        }
        else if (val.length > 63) {
            callback("Display name should have at most 63 characters.");
        }
        else if (!displayNameRegex.test(val)) {
            callback("Display name must start and end with a lowercase letter or digit; only lowercase letters, digits, hyphens, and dots (e.g. name or name.subname) are allowed.");
        }
        else {
            callback();
        }
    }
    else if (rule.field === "databaseName") {
        if (!val) {
            callback("Please enter database name!");
        }
        else if (!/^[a-z0-9]/.test(val)) {
            callback("Database name must start with a lowercase letter or a digit.");
        }
        else if (/[^a-z0-9_]/.test(val)) {
            callback("Database name can only contain lowercase letters, digits, and underscores.");
        }
        else if (!/[a-z0-9]$/.test(val)) {
            callback("Database name must end with a lowercase letter or a digit.");
        }
        else {
            if (val.length > 63) {
                callback("Database name should have at most 63 characters.");
            }
            else {
                callback();
            }
        }
    }
    else if (rule.field === "username") {
        if (!val) {
            callback("Please enter username!");
        }
        else if (!/^[a-z0-9]/.test(val)) {
            callback("Username must start with a lowercase letter or a digit.");
        }
        else if (/[^a-z0-9_]/.test(val)) {
            callback("Username can only contain lowercase letters, digits, and underscores.");
        }
        else if (!/[a-z0-9]$/.test(val)) {
            callback("Username must end with a lowercase letter or a digit.");
        }
        else {
            if (val.length > 63) {
                callback("Username should have at most 63 characters.");
            }
            else {
                callback();
            }
        }
    }
}

export const validateSpaces = (rule, value, callback) => {
    let regex = /^(?!\s)(.*\s+.*)(?<!\s)$/;
    if (regex.test(value?.toString().trim())) {
        callback("Please remove the spaces from this field.");
    }
    else {
        callback();
    }

}

function ifObj(err) {
    if (Array.isArray(Object.values(err)[0])) {
        console.log("Object.values(err)[0][0] :", Object.values(err)[0][0]);
        return Object.values(err)[0][0];
    }
    else if (typeof Object.values(err)[0] === 'object') {
        // missing return here made every nested error_details resolve to undefined
        return ifObj(Object.values(err)[0]);
    }
    else {
        console.log("Object.values(err)[0] :", Object.values(err)[0][0]);
        return Object.values(err)[0];
    }
}

export function formatErrors(err) {
    console.log("inside formatErrors :", err);
    if (Array.isArray(err)) {
        if (typeof err[0] === 'object') {
            return ifObj(err);
        }
        else {
            return err[0];
        }
    }
    else if (typeof err === 'object') {
        // console.log("error is object :", err);
        return ifObj(err);
    }
    else if (typeof err === 'string') {
        // console.log("error is object :", err);createPro
        return err;
    }
}

export function hasPermission(checkForPermission) {
    if (localStorage.getItem("profile-data")) {
        let userProfile = JSON.parse(localStorage.getItem("profile-data"));
        // Global super-admin sees and does everything, regardless of granular
        // per-org permissions (a superadmin account may hold none). Without
        // this bypass the sidebar/routes only show the isSuperUser()-gated
        // items (Organisation Plans, AI Usage, Audit) and hide Dashboard /
        // Clusters / etc.
        if (userProfile?.super) {
            return true;
        }
        const perms = userProfile?.permissions;
        if (!Array.isArray(perms)) {
            return false;
        }
        // ``checkForPermission`` may be a single identifier or an array of
        // acceptable aliases. The array form lets a call site match whether
        // the profile carries the codename (``create_cloud_resource``) or the
        // verbose display name (``Can create cloud resource``) — show if
        // EITHER is present. Single-string callers are unaffected.
        if (Array.isArray(checkForPermission)) {
            return checkForPermission.some((p) => perms.includes(p));
        }
        return perms.includes(checkForPermission);
    }
    else {
        return false;
    }
}

// Mirror of the backend's ``IsOrganisationAdminOrHasPermission`` admin
// check. Use this anywhere a control writes to an endpoint that the
// backend gates as admin-only — there's no point letting a non-admin
// click a button whose POST/PUT will come back 403.
//
// The same ``profile-data.roles.includes('Admin')`` pattern is already
// inlined in DashboardRoutes, RecommendationsTab, Sidebar, etc.; this
// is the shared helper version so call sites don't drift.
export function isOrgAdmin() {
    if (localStorage.getItem("profile-data")) {
        const profile = JSON.parse(localStorage.getItem("profile-data"));
        return Array.isArray(profile?.roles) && profile.roles.includes('Admin');
    }
    return false;
}

// The signed-in user's own id, or null when the profile cache is empty.
export function getCurrentUserId() {
    if (localStorage.getItem("profile-data")) {
        const profile = JSON.parse(localStorage.getItem("profile-data"));
        return profile?.id ?? null;
    }
    return null;
}

// True when Member is the user's ONLY role (see the backend's ``Member_Role``).
// Members may act only on resources they created, so controls that would
// attribute a resource to someone else are locked to themselves.
//
// The "sole role" test is deliberate, and mirrors the backend's own convention
// for Read Only in ``get_normalized_permissions_for_object``
// (``len(roles) == 1 and ... "read only"``): a user who also holds another role
// is granted whatever that role allows, so the Member restriction must not
// apply to them. Admin is covered for free — holding it means roles.length > 1.
export function isMemberOnly() {
    if (localStorage.getItem("profile-data")) {
        const profile = JSON.parse(localStorage.getItem("profile-data"));
        if (!Array.isArray(profile?.roles) || profile.roles.length !== 1) return false;
        return String(profile.roles[0]).trim().toLowerCase() === 'member';
    }
    return false;
}

// True when the signed-in user is on a personal (single-user) workspace —
// the auto-created org for Individual signups. Personal workspaces have no
// team: hide invite/users/roles UI and AI features behind this check.
export function isPersonalWorkspace() {
    if (localStorage.getItem("profile-data")) {
        const profile = JSON.parse(localStorage.getItem("profile-data"));
        return profile?.organisation_type === 'personal';
    }
    return false;
}

// ── Plan entitlements (capabilities / tiers) ────────────────────────────────
// The org's EFFECTIVE entitlements as resolved by the backend — plan base ⊕ the
// super-admin's per-org overrides (Super Admin → Organisation Plans). Cached in
// localStorage by ContextProvider at boot, exactly like `profile-data`, so
// gating is a synchronous read at any call site — including the plain functions
// that build the sidebar (`Sidebar/options.js`) and the cluster tab list.
export function getEntitlements() {
    try {
        return JSON.parse(localStorage.getItem('entitlements-data')) || null;
    } catch (_) {
        return null;
    }
}

// True when the org's plan (or its per-org override) allows `key`, e.g.
// `security_scan`, `cost_recommend`, `cost_actuation`, `ai_assistant`.
// Fails OPEN: an unknown key, or a snapshot we haven't fetched yet, must never
// hide a surface the org is paying for. `sre_auto_fix` is an enum, so anything
// above suggest-only counts as enabled — mirrors entitlements.service.is_enabled.
export function featureEnabled(key) {
    const features = getEntitlements()?.features;
    if (!features || !(key in features)) return true;
    const value = features[key];
    if (key === 'sre_auto_fix') return value === 'auto-pr' || value === 'auto-apply';
    return !!value;
}

// Graded tier value (`sre_llm`, `scan_frequency`, `history_retention_days`).
// `undefined` when the snapshot isn't loaded — treat that as "no opinion".
export function tierValue(key) {
    return getEntitlements()?.tiers?.[key];
}

export function isSuperUser() {
    // console.log('localStorage.getItem("profile-data") :', localStorage.getItem("profile-data"));
    let myData = localStorage.getItem("profile-data");
    console.log("checking for super user :", myData);
    if (myData) {
        let userProfile = JSON.parse(myData);
        console.log("userProfile in isSuperUser :", userProfile);
        if (userProfile.super) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export const permissionReducer = (state, action) => {
    console.log("Action title: ", action.title);
    console.log("Action type: ", action.type);
    console.log("state: ", state);
    switch (action.title) {
        case "Project Blueprints": return 'add_project'
        case "Projects": return 'add_project'    // this is for infra projects
        case "Workspaces": return 'add_project'    // this is for infra projects
        case "Runs": return 'add_project'    // this is for infra projects
        case "Project Services":
            switch (action.type) {
                case "CREATE": return 'add_project'
                case "DELETE": return 'delete_project'
                case "UPDATE": return 'add_project'
                case "VIEW_SECRET": return 'view_secret'
                //case ""
                default: return 'add_project'
            }
        case "Environment Variables": return 'add_project'
        case "Clusters": return 'create_cluster'
        case "Nodegroups Details": return 'create_cluster'
        case "Nodepools Details": return 'create_cluster'
        case "RBAC":
            switch (action.type) {
                case "CREATE": return 'create_rbac_role'
            }
        case "Environments": return 'add_environment'
        case "Add Environment": return 'add_environment'
        case "Environment Overview": return 'change_environment'
        case "Add Services": return 'change_environment'
        case "Services Overview": return 'change_environment'
        case "Add New Services": return 'change_environment'
        case "Edit Service": return 'change_environment'

        case "Security": return 'can_do_security_scan'
        case "Marketplace": return 'manage_repository'
        case "Helm Charts": return 'deploy_helm'
        case "Security Scans": return 'can_do_security_scan'
        case "Deploy Marketplace":
            switch (action.type) {
                case "CREATE": return 'deploy_helm'
                case "DELETE": return 'delete_helm'
                case "UPDATE": return 'update_helm'
                case "DEPLOY": return 'deploy_helm'
            }
        case "Add Repositories": return 'manage_repository'
        case "Users": return 'invite_user'
        case "Roles": return 'add_role'
        case "Integrations": return 'integrate_account'
        case "Workflow Details": return 'change_workflows'
        case "Workspace Details": return 'change_workflows'
        case "InfraWorkspace": return 'change_workflows'
        case "Workflow Release Details": return 'change_workflows'
        case "Guardrail List": return 'add_guardrail'
        case "Create Guardrail": return 'add_guardrail'
        default: return state
    }
};

export const fetchingReducer = (state, action) => {
    switch (action.status) {
        case 'loading':
            return {
                ...state,
                [action.loader]: true
            };
        case 'loaded':
            return {
                ...state,
                [action.loader]: false
            };
        default:
            return state;
    }
}

export const fetchingComponentReducer = (state, action) => {
    switch (action.status) {
        case 'loading':
            return {
                ...state,
                [action.loader]: {
                    ...state[action.loader],
                    value: true,
                    nestLevel: action.nestLevel || 0,
                    height: action.height || false,
                },
            };
        case 'loaded':
            return {
                ...state,
                [action.loader]: {
                    ...state[action.loader],
                    value: false,
                    nestLevel: action.nestLevel || 0,
                    height: action.height || false,
                },
            };
        case 'reset':
            return {};
        default:
            return state;
    }
}

export const showLoader = (loader = {}, nestLevel = 0) => {
    return Object.values(loader).some((val) => val.value === true && val.nestLevel === nestLevel) &&
        !Object.values(loader).some((val) => val.value === true && val.nestLevel < nestLevel);
}

// export function checkDummyUser = () => {
// }
export function formatTime(seconds) {
    if ((seconds / 31536000) > 1) {
        let time = Math.floor(seconds / 31536000);
        return time + (time === 1 ? " year" : " years");
    }
    // const interval = seconds / 2592000;
    if ((seconds / 2592000) > 1) {
        let time = Math.floor(seconds / 2592000);
        return time + (time === 1 ? " month" : " months");
    }
    // const interval = seconds / 86400;
    if ((seconds / 86400) > 1) {
        let time = Math.floor(seconds / 86400);
        return time + (time === 1 ? " day" : " days");
    }
    // const interval = seconds / 3600;
    if ((seconds / 3600) > 1) {
        let time = Math.floor(seconds / 3600);
        return time + (time === 1 ? " hour" : " hours");
    }
    // const interval = seconds / 60;
    if ((seconds / 60) > 1) {
        let time = Math.floor(seconds / 60);
        return time + (time === 1 ? " min" : " mins");
    }
    // if interval is less then 0
    if (Math.floor(seconds) < 0) {
        return "0 second";
    }

    let time = Math.floor(seconds);
    return time + (time === 1 ? " second" : " seconds");
}

export function timeSince(date) {
    // console.log("date in timeSince :", date);
    if (!date || isNaN(new Date(date).getTime())) {
        return "-"; // Return "-" for invalid or null values
    }
    let seconds = Math.floor((new Date() - date) / 1000);
    // console.log("seconds in timeSince :", seconds);
    return formatTime(seconds);

}
export function UpSince(seconds) {
    // If seconds are less than 0, return 0 seconds
    return formatTime(seconds);
}


export function ConvertUTCToLocal(rawDate, inDays) {
    const dayFormat = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
    const timeFormat = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
    return new Date(rawDate).toLocaleString("en-US", inDays ? dayFormat : timeFormat);
}

export function ConvertUTCToLocalDate(rawDate) {
    const dateFormat = { month: 'short', day: 'numeric', year: 'numeric' };
    return new Date(rawDate).toLocaleString("en-US", dateFormat);
}

export function PasswordValidator(value) {
    if (validator.isStrongPassword(value, {
        minLength: 8, minLowercase: 1,
        minUppercase: 1, minNumbers: 1, minSymbols: 1
    })) {
        return true;
    } else {
        return false;
    }
}

export function RemoveClusterFromLocal() {
    localStorage.removeItem("Cluster");
    localStorage.removeItem("updateCluster");
    localStorage.removeItem("oneClickCluster");
    localStorage.removeItem("clusterTabSelected");
    localStorage.removeItem("isRegionAvailable");
    localStorage.removeItem("availablilityZones");
    localStorage.removeItem("no_of_azs");
}

export function RemoveEnvironmentFromLocal() {
    localStorage.removeItem("app-data");
    localStorage.removeItem("service-categories");
    localStorage.removeItem("dataSourcesData");
    localStorage.removeItem("ProjectDep");
    localStorage.removeItem("servicesEnabled");
    localStorage.removeItem("redisData");
    localStorage.removeItem("mongoDataSourcesData");
    localStorage.removeItem("stopFetch");
    localStorage.removeItem("deploymentData");
    localStorage.removeItem("container-registries");
    localStorage.removeItem("selectedProjectData");
    localStorage.removeItem("postgresDataSourcesData");
}

export function RemoveCloneEnvironmentFromLocal() {
    localStorage.removeItem("cloneAppData");
    localStorage.removeItem("cloneServiceCategories");
    localStorage.removeItem("cloneDataSourcesData");
    localStorage.removeItem("cloneSelectedProjectData");
    localStorage.removeItem("cloneServicesEnabled");
    localStorage.removeItem("cloneRedisData");
    localStorage.removeItem("cloneMongoDataSourcesData");
    localStorage.removeItem("stopFetch");
    localStorage.removeItem("cloneDeploymentData");
    localStorage.removeItem("cloneContainerRegistries");
    localStorage.removeItem("ProjectDep");
    localStorage.removeItem("clonePostgresDataSourcesData");
    localStorage.removeItem("importantFields");
    localStorage.removeItem("stopFetch");
}


export const EmailValid = (test) => {
    let invalidEmails = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@outlook.com", "@live.com", "@aol.com", "@icloud.com", "@mail.com", "@yandex.com", "@zoho.com", "@gmx.com", "@inbox.com", "@fastmail.com", "@me.com", "@msn.com", "@yahoo.co.uk", "@yahoo.co.in", "@hotmail.co.uk", "@hotmail.fr", "@sbcglobal.net", "@comcast.net", "@verizon.net", "@bellsouth.net", "@att.net", "@cox.net", "@charter.net", "@optonline.net", "@earthlink.net", "@qq.com", "@naver.com", "@hanmail.net", "@nate.com", "@163.com", "@126.com", "@protonmail.com", "@tutanota.com", "@yopmail.com", "@mailinator.com", "@trashmail.com", "@10minutemail.com"];

    let emails = invalidEmails.filter((item) => test.endsWith(item));

    if (emails.length > 0) {
        return false;
    }
    else {
        return true;
    }

}

export const copyText = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return "Copied";
    }
    catch (err) {
        console.log("Error", err);
        return "Failed";
    }
}
// Custom sorting function based on search input
export const customSortOptions = (optionA, optionB, searchValue) => {
    // Use data-label if available, otherwise fallback to value
    const valueA = optionA['data-label'] || optionA.value || '';
    const valueB = optionB['data-label'] || optionB.value || '';

    // Exact match should come before partial matches
    const optionAExactMatch = valueA === searchValue;
    const optionBExactMatch = valueB === searchValue;

    if (optionAExactMatch && !optionBExactMatch) {
        return -1; // optionA comes before optionB
    } else if (!optionAExactMatch && optionBExactMatch) {
        return 1; // optionB comes before optionA
    }
    else {
        // Check if either starts with the search value
        const aStartsWith = valueA.toLowerCase().startsWith(searchValue ? searchValue.toLowerCase() : "");
        const bStartsWith = valueB.toLowerCase().startsWith(searchValue ? searchValue.toLowerCase() : "");

        if (aStartsWith && !bStartsWith) {
            return -1; // a comes before b
        } else if (!aStartsWith && bStartsWith) {
            return 1; // b comes before a
        } else {
            return valueA.localeCompare(valueB); // alphabetical sorting
        }
    }
    // else {
    //   // Default alphabetical sorting if neither or both are exact matches
    //   return optionA.value.localeCompare(optionB.value);
    // }
};

// Custom filtering function based on search input
export const customFilterOption = (inputValue, option) => {
    if (option['data-label']) {
        return option['data-label'].toLowerCase().includes(inputValue.toLowerCase());
    }
    
    if (isNaN(option.value)) {
        const optionValue = option.value ? option.value.toLowerCase() : "";
        return optionValue.includes(inputValue.toLowerCase());
    }
    else {
        if (typeof option.children === "string") {
            const optionValue = option.children ? option.children.toLowerCase() : "";
            return optionValue.includes(inputValue.toLowerCase());
        }
    }
};

export async function validateYaml(yamlString, clusterId, updateDep, envNamespace, callApi, form) {
    try {
        console.log("My yaml string: ", yamlString);
        const doc = yaml.loadAll(yamlString);
        console.log("My doc: ", doc);
        if (callApi) {
            let data = await backendYamlValidate(Array.isArray(doc) ? doc.flat() : [doc], clusterId, updateDep, envNamespace, form);
            form.setFields([{ name: "yamlData", errors: [] }]);
        }
        console.log("Returned val: ", doc);
        return Array.isArray(doc) ? doc.flat() : [doc];
    } catch (err) {
        console.log("Failed", err);
        if (form) {
            form.setFields([{
                name: "yamlData",
                errors: err && err?.error_details ? err.error_details?.yaml_content : ["Your provided yaml code is invalid."]
            }]);
        }
        throw err;
    }
}

// Wrapper keys that carry no information for the user — the label comes from the
// nearest meaningful key instead (a service name, a field name).
const ERROR_WRAPPER_KEYS = new Set(["services", "non_field_errors", "detail", "error", "errors", "message", "yaml_content"]);

// error_details is a DRF error tree, nested arbitrarily deep:
//   { services: { bitbucket: { non_field_errors: ["…kind Deploymentpoda…"] } } }
// Flatten it to "bitbucket: …kind Deploymentpoda…" lines so nested messages reach
// the UI instead of being swallowed by a generic "something went wrong".
export function flattenErrorDetails(details, label = "") {
    if (details === null || details === undefined) return [];
    if (typeof details === "string") return [label ? `${label}: ${details}` : details];
    if (Array.isArray(details)) return details.flatMap((val) => flattenErrorDetails(val, label));
    if (typeof details === "object") {
        return Object.entries(details).flatMap(([key, val]) =>
            flattenErrorDetails(val, ERROR_WRAPPER_KEYS.has(key) || !isNaN(key) ? label : key));
    }
    return [];
}

// Same tree, but for the yamlData form field — messages only, no service labels.
export function yamlErrorList(err) {
    const messages = flattenErrorDetails(err?.error_details || err?.response?.data?.error_details);
    return messages.length ? messages : ["Your YAML code provided is invalid."];
}

export async function backendYamlValidate(yaml, clusterId, updateDep, envNamespace, form) {
    console.log("My yaml: ", yaml);
    try {
        const res = await api.post(process.env.REACT_APP_API_URI + "/api/project_env/env/yaml-validation/", {
            "cluster_unique_id": clusterId,
            "yaml_content": yaml,
            "is_update_operation": updateDep,
            "env_namespace": envNamespace
        });
        if (res.data?.status) {
            return res.data;
        }
        throw res.data;
    }
    catch (err) {
        // axios rejects on 4xx, so the details sit on err.response.data.
        const errors = yamlErrorList(err);
        if (form) {
            form.setFields([{ name: "yamlData", errors }]);
        }
        throw { error_details: { yaml_content: errors } };
    }
}

/**
 * Parses YAML string to JSON array
 * @param {string} yamlString - The YAML string to parse
 * @returns {Array} Array of parsed JSON objects
 * @throws {Error} If YAML parsing fails
 */
export function parseYamlToJson(yamlString) {
    try {
        if (!yamlString || typeof yamlString !== 'string') {
            throw new Error('YAML string is required');
        }
        const parsedYaml = yaml.loadAll(yamlString);
        // Convert to array of JSON objects (yaml.loadAll already returns array of objects)
        return Array.isArray(parsedYaml) ? parsedYaml.flat() : [parsedYaml];
    } catch (error) {
        console.error("Error parsing YAML:", error);
        throw error;
    }
}


export const yamlLinter = (view, form) => {
    const errors = [];
    const docString = view.state.doc.toString();
    console.log("Beginning yaml linting...", docString);
    try {
        yaml.loadAll(docString);
        if (form) {
            form.setFields([{ name: "yamlData", errors: [] }]);
        }
    } catch (error) {
        if (error.name === 'YAMLException') {
            console.log("Error: ", error);
            errors.push({
                from: error.mark?.position,
                to: error.mark?.position + 1,
                message: error.reason,
                severity: "error"
            });
            if (form) {
                form.setFields([{
                    name: "yamlData",
                    errors: ["Your YAML code provided is invalid."]
                }]);
            }
        }
        console.log("Error:", error);
    }

    // Check for reserved "atmosly_app" prefix keys inside labels: sections
    const lines = docString.split('\n');
    let inLabels = false;
    let labelsIndent = -1;
    let charPos = 0;

    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const trimmed = line.trimStart();
        const currentIndent = line.length - trimmed.length;

        if (trimmed !== '' && trimmed.match(/^labels\s*:/)) {
            inLabels = true;
            labelsIndent = currentIndent;
            charPos += line.length + 1;
            continue;
        }

        if (inLabels) {
            if (trimmed === '') {
                charPos += line.length + 1;
                continue;
            }
            if (currentIndent <= labelsIndent) {
                inLabels = false;
                labelsIndent = -1;
                // current line may itself open a new labels block
                if (trimmed.match(/^labels\s*:/)) {
                    inLabels = true;
                    labelsIndent = currentIndent;
                }
            } else {
                const keyMatch = trimmed.match(/^([^\s:]+)\s*:/);
                if (keyMatch && keyMatch[1].startsWith('atmosly_app')) {
                    const from = charPos + currentIndent;
                    errors.push({
                        from,
                        to: from + keyMatch[1].length,
                        message: `Key "${keyMatch[1]}" uses the reserved prefix "atmosly_app" and is not allowed in labels.`,
                        severity: "warning"
                    });
                }
            }
        }

        charPos += line.length + 1;
    }

    return errors;
};

export const workflowPipelineSettings = {
    hideAdd: true,
    hideDelete: true,
    hideStatus: true
};

export const compareProps = (prevProps, nextProps) => {
    console.log("Prev and next: ", prevProps, nextProps, prevProps.serviceSelected.isActive, nextProps.serviceSelected.isActive);
    if (prevProps.serviceSelected.isActive !== nextProps.serviceSelected.isActive) {
        return false;
    }
    else if (prevProps.nodeGroupList.join() !== nextProps.nodeGroupList.join()) {
        return false;
    }
    else if (prevProps.refreshNodegroups !== nextProps.refreshNodegroups) {
        return false;
    }
    else if ((prevProps.serviceHighlighted?.id !== nextProps.serviceHighlighted?.id) || (prevProps.serviceHighlighted?.service_id !== nextProps.serviceHighlighted?.service_id)) {
        return false;
    }
    else if (prevProps.lastEnabledService !== nextProps.lastEnabledService) {
        return false;
    }
    else if (prevProps.updateFetched !== nextProps.updateFetched) {
        return false;
    }
    else if (prevProps.cloneFetched !== nextProps.cloneFetched) {
        return false;
    }
    else if (prevProps.generateImpField !== nextProps.generateImpField) {
        return false;
    }
    else if (prevProps.updateEnabled !== nextProps.updateEnabled) {
        return false;
    }
    else if (prevProps.toggleChanged !== nextProps.toggleChanged) {
        return false;
    }
    else if (prevProps.subnetIds.length !== nextProps.subnetIds.length) {
        return false;
    }
    return true;
}
// converts the date to dd monthName year format
export default function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
}

// Helper function to check if a step exists and has succeeded
export const hasSucceeded = (step) => !step || (step && step.status === "Succeeded");

export const validateBackupRetention = (rule, value, callback) => {
    if (!value) {
        callback();
    }
    if (isNaN(value)) {
        callback("This field should contain only numbers.");
    }
    if (value < 0) {
        callback("Backup retention should be at least 0");
    }
    else {
        callback();
    }
}

export const convertToLabels = (arr = []) => {
    const valueMap = {
        "edit": "update",
        "view": "view",
        "delete": "delete",
        "deploy": "deploy",
        "terminal": "exec_terminal"
    };
    return arr.map((val) => ({ value: valueMap[val], label: val }));
}


export const convertTextStatus = {
    0: "Pending",
    1: "Running",
    2: "Failed",
    3: "Succeeded",
    4: "Waiting for Approval",
}

export const hasObjectPermision = (entry = {}, perm = "view") => {
    return entry.permissions?.includes(perm) ? true : false;
} 

export const convertWorkflowTextTypes = {
    "source": "sourceConfig",
    "build": "buildConfig",
    "push": "pushConfig",
    "deploy": "deployConfig",
    "secret_detect": "sourceConfig",
    "post_build_custom_script": "sourceConfig",
}

export const convertTextType = {
    "0": "array",
    "list(string)": "listString",
    "map(string)": "mapString",
    "map(any)": "mapAny",
    "4": "object",
    "bool": "boolean",
}

export const convertInfraText = {
    "InfraProject": "Project",
    "InfraRuns": "Run",
    "InfraWorkspace": "Workspace",
    "InfraWorkspaceRuns": "Run",
    "InfraWorkspaceAssResources": "Associated Resources",
    "InfraWorkspaceOutputs": "Outputs"
}

function jsonKind(val) {
    if (Array.isArray(val)) return 'array';
    if (val === null) return 'null';
    if (typeof val === 'object') return 'object';
    return typeof val;            // 'string', 'number', 'boolean', etc.
}

function checkJsonString(str) {
    try {
        const parsed = JSON.parse(str);

        // 1) Array?
        if (Array.isArray(parsed)) {
            // empty array → treat as listString
            if (parsed.length === 0) {
                return { valid: true, types: ['listString'], value: parsed };
            }

            // inspect element kinds
            const kinds = parsed.map(jsonKind);
            const unique = Array.from(new Set(kinds));

            if (unique.length === 1 && unique[0] === 'string') {
                return { valid: true, types: ['listString'], value: parsed };
            }
            // otherwise just a generic array
            return { valid: true, types: ['array'], value: parsed };
        }

        // 2) Plain object?
        if (parsed !== null && typeof parsed === 'object') {
            const vals = Object.values(parsed);
            // empty object → treat as mapString
            if (vals.length === 0) {
                return { valid: true, types: ['mapString', 'mapAny'], value: parsed };
            }

            const kinds = vals.map(jsonKind);
            const unique = Array.from(new Set(kinds));

            // all-string or empty → mapString
            if (unique.length === 1 && unique[0] === 'string') {
                // map(string)
                return { valid: true, types: ['mapString'], value: parsed };
            }

            // any uniform non-string → mapAny
            if (unique.length === 1) {
                return { valid: true, types: ['mapAny'], value: parsed };
            }

            // Mixed-type object
            return { valid: true, types: ['object'], value: parsed };
        }

        // 3) Boolean?
        if (typeof parsed === 'boolean') {
            return { valid: true, types: ['boolean'], value: parsed };
        }

        // 4) Anything else (number, string, null)
        return { valid: true, types: ['other'], value: parsed };
    } catch {
        // Not valid JSON
        return { valid: false, types: ['invalid'], value: null };
    }
}

// convenience wrappers:
export function isValidAny(str) {
    return checkJsonString(str).valid;
}

export function isValidList(str) {
    return checkJsonString(str).types.includes('array');
}

export function isValidListString(str) {
    return checkJsonString(str).types.includes('listString');
}

export function isValidMapString(str) {
    return checkJsonString(str).types.includes('mapString');
}

export function isValidMapAny(str) {
    return checkJsonString(str).types.includes('mapAny');
}

export function isValidDict(str) {
    return checkJsonString(str).types.includes('object');
}

export function isValidBool(str) {
    return checkJsonString(str).types.includes('boolean');
}

export function isValidCommon(str, type) {
    if (type && type !== "any") {
        return checkJsonString(str).types.includes(type);
    }
    else {
        return true
    }
}

// Alert styles
export const icons = {
    warning: <WarningFilled style={{ color: "#F6C344", fontSize: "15px" }} />,
    error: <WarningFilled style={{ color: "#D20A0A", fontSize: "15px" }} />,
    info: <WarningFilled style={{ color: "#6486EE", fontSize: "15px" }} />,
    onlyInfo: <InfoCircleFilled style={{ color: "#6486EE", fontSize: "15px" }} />,
    progress: <LoadingOutlined style={{ color: "#6486EE", fontSize: "15px" }} spin />
};

export const borders = {
    warning: "1px solid #F6C344",
    error: "1px solid #D20A0A",
    info: "1px solid #6486EE",
    onlyInfo: "1px solid #6486EE",
    progress: "1px solid #6486EE"
};

export const background = {
    warning: "#FFF3E0",
    error: "#FFEBEE",
    info: "#EEF2FF",
    onlyInfo: "#EEF2FF",
    progress: "#EEF2FF"
};

export const capitalizeFirst = (str = "") => {
    if (str == null || str === "") return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// Post-install grace for agent addons (ops-agent / debug-agent). A freshly
// (re)installed agent reports its addon status as Succeeded before its pod boots
// and registers with the backend, so agent_flavours is briefly false for it — which
// would flash "Disconnected" on the card + banner even though it's just coming up.
// We suppress that ONLY for an agent THIS browser session just installed, keyed in
// sessionStorage so it survives the post-install auto-refresh and F5, and self-expires
// after the connectivity window. A Succeeded agent still not connected on a later /
// plain load has no marker, so it correctly surfaces as disconnected.
export const AGENT_ADDON_IDS = new Set(["ops-agent", "debug-agent"]);
export const AGENT_INSTALL_GRACE_MS = 5 * 60 * 1000;
const agentInstallGraceKey = (clusterId, addon) => `agentInstalledAt:${clusterId}:${addon}`;
export const markAgentInstalled = (clusterId, addon) => {
    if (!clusterId || !AGENT_ADDON_IDS.has(addon)) return;
    try { sessionStorage.setItem(agentInstallGraceKey(clusterId, addon), String(Date.now())); } catch (e) { /* storage unavailable */ }
};
export const isWithinAgentInstallGrace = (clusterId, addon) => {
    if (!clusterId) return false;
    try {
        const t = Number(sessionStorage.getItem(agentInstallGraceKey(clusterId, addon)));
        return !!t && (Date.now() - t) < AGENT_INSTALL_GRACE_MS;
    } catch (e) { return false; }
};

// Function to generate a secure password
export const generatePassword = () => {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
        password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
};

export const timeContext = {
    "hr": "h",
    "min": "m",
    "sec": "s",
    "h": "hr",
    "m": "min",
    "s": "sec",
}

// Common function to check if form data has changed from initial state
export const hasFormDataChanged = (updateDep, initialFormData, form, setInitialFormData, setTooltip, setEditServiceDataChanged, currentState = null, initialState = null) => {
    console.log("Has form data changed called: ", updateDep, initialFormData);
    if (!updateDep || !initialFormData) {
        return false;
    }
    
    const currentFormData = form.getFieldsValue();
    
    // Handle the case where domain field might be added later
    const normalizedCurrentData = { ...currentFormData };
    const normalizedInitialData = { ...initialFormData };
    
    // If domain field is missing from initial data but present in current data, 
    // add it to initial data with the same value to avoid false positive
    // if (!("domain" in normalizedInitialData) && "domain" in normalizedCurrentData) {
    //     normalizedInitialData.domain = normalizedCurrentData.domain;
    //     setInitialFormData({...initialFormData, domain: normalizedCurrentData.domain});
    // }
    
    // Deep comparison function that handles type differences (int vs string)
    const deepCompare = (obj1, obj2) => {
        if (obj1 === obj2) return true;
        if (obj1 == null || obj2 == null) return obj1 === obj2;
        if (typeof obj1 !== typeof obj2) {
            // Handle type coercion for numbers and strings
            if ((typeof obj1 === 'number' && typeof obj2 === 'string') || 
                (typeof obj1 === 'string' && typeof obj2 === 'number')) {
                return obj1 == obj2; // Use loose equality for type coercion
            }
            return false;
        }
        if (typeof obj1 !== 'object') return obj1 == obj2; // Use loose equality
        
        if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;
        
        if (Array.isArray(obj1)) {
            if (obj1.length !== obj2.length) return false;
            for (let i = 0; i < obj1.length; i++) {
                if (!deepCompare(obj1[i], obj2[i])) return false;
            }
            return true;
        }
        
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;
        
        for (let key of keys1) {
            if (!keys2.includes(key)) return false;
            if (!deepCompare(obj1[key], obj2[key])) return false;
        }
        return true;
    };
    
    // const hasChanged = !deepCompare(normalizedCurrentData, normalizedInitialData);
    // console.log("Form data changed:", hasChanged, "Current:", normalizedCurrentData, "Initial:", normalizedInitialData);

    // Check form data changes
    const formDataChanged = !deepCompare(normalizedCurrentData, normalizedInitialData);
    
    // Check state changes (for switches and other non-form elements)
    let stateChanged = false;
    if (currentState && initialState) {
        stateChanged = !deepCompare(currentState, initialState);
    }
    
    const hasChanged = formDataChanged || stateChanged;
    
    console.log("Form data changed:", formDataChanged, "State changed:", stateChanged, "Overall changed:", hasChanged);
    console.log("Current form:", normalizedCurrentData, "Initial form:", normalizedInitialData);
    if (currentState && initialState) {
        console.log("Current state:", currentState, "Initial state:", initialState);
    }
    
    setEditServiceDataChanged(!hasChanged);
    if(!hasChanged){
        setTooltip("No changes detected. Make changes to enable re-deploy.");
    }
    else{
        setTooltip(false);
    }
    return hasChanged;
};

// Common function to capture initial form data
export const captureInitialFormData = (updateDep, dataSources, form, initialFormData, setInitialFormData, checkField = 'displayName') => {
    if (updateDep && dataSources && form.getFieldsValue() && Object.keys(form.getFieldsValue()).length > 0) {
        console.log("form.getFieldsValue() :", form.getFieldsValue());
        const currentFormData = form.getFieldsValue();
        if (!initialFormData && currentFormData[checkField]) {
            setInitialFormData(JSON.parse(JSON.stringify(currentFormData)));
        }
    }
};

// Common function to capture initial state data
export const captureInitialStateData = (updateDep, currentState, initialState, setInitialState, checkField = 'serviceName') => {
    if (updateDep && currentState && Object.keys(currentState).length > 0) {
        console.log("currentState :", currentState);
        if (!initialState && currentState[checkField]) {
            setInitialState(JSON.parse(JSON.stringify(currentState)));
        }
    }
};


// Deep clone function that preserves undefined values
export const deepClonePreservingUndefined = (obj) => {
    if (obj === null || typeof obj !== 'object') return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (Array.isArray(obj)) return obj.map(item => deepClonePreservingUndefined(item));
    
    const cloned = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            cloned[key] = deepClonePreservingUndefined(obj[key]);
        }
    }
    return cloned;
};


export const credsManagementContext = {
    "create_repository": {
        label: "Create Repository",
        message: ""
    },
    "delete_repository": {
        label: "Delete Repository",
        message: ""
    },
    "get_image": {
        label: "Get Image",
        message: ""
    },
    "list_images": {
        label: "List Images",
        message: ""
    },
    "pull_image": {
        label: "Pull Image",
        message: ""
    },
    "push_image": {
        label: "Push Image",
        message: ""
    },
    "create_secret": {
        label: "Create Secret",
        message: ""
    },
    "get_secret": {
        label: "Get Secret",
        message: ""
    },
    "put_secret": {
        label: "Put Secret",
        message: ""
    },
    "update_secret": {
        label: "Update Secret",
        message: ""
    },
    "list_secrets": {
        label: "List Secrets",
        message: ""
    },
    "delete_secret": {
        label: "Delete Secret",
        message: ""
    },
    "describe_secret": {
        label: "Describe Secret",
        message: ""
    }
}

// The ACM certificate field's fixed "make me a new one" choice. It doubles as
// the stored value so the AutoComplete input shows the label instead of going
// blank; the backend gets "" (its signal to request a new certificate).
export const ACM_CREATE_NEW = "Create new certificate";
// Typed values are normalized: the backend matches the domain exactly, so a
// stray space or capital would quietly request a new certificate instead of
// reusing the existing one.
export const acmCertificateForPayload = (value) => {
    const val = (value || "").toString().trim();
    return !val || val === ACM_CREATE_NEW ? "" : val.toLowerCase();
};

export const normalizeDomain = (value) => (value || "").toString().trim().replace(/\.$/, "").toLowerCase();
export const acmZoneMismatch = (certificate, zone) => {
    const zoneName = normalizeDomain(zone);
    const certDomain = normalizeDomain(certificate).replace(/^\*\./, "");
    if (!zoneName || !certDomain) {
        return false;
    }
    return certDomain !== zoneName && !certDomain.endsWith(`.${zoneName}`);
};
